import { validateZipcode } from "core/model/utils/location";
import { validateCharacterLimit } from "core/model/utils/strings";
import {
  DRG_CODE_CHARACTER_LIMIT,
  ICD_CODE_CHARACTER_LIMIT,
  IK_NUMBER_CHARACTER_LIMIT,
  INFECTIONS_CHARACTER_LIMIT,
  PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
} from "core/schemas/shared";
import { convertModelDefinition, ibanDef, valueDef } from "react-forms-state";

export const DRVmedicalFormDefinition = convertModelDefinition({
  // INTRO
  ...valueDef("statutory_pension_insurance_number", {
    validate: (value, props) =>
      validateCharacterLimit(PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT)(
        value,
        props,
      ),
  }),
  ...valueDef("hospital_name_address"),
  ...valueDef("social_worker_name_number"),
  ...valueDef("preferred_rehab_clinic"),
  ...valueDef("pension_procedure_direct"),
  ...valueDef("pension_procedure_after_examination"),
  ...valueDef("full_reha"),
  ...valueDef("day_reha"),
  ...valueDef("patient_name"),
  ...valueDef("patient_birthdate"),
  ...valueDef("patient_street_housenumber"),
  ...valueDef("patient_city"),
  ...valueDef("patient_zipcode", { validate: validateZipcode(false) }),
  ...valueDef("admission_date"),
  ...valueDef("rehab_triggering_event_date"),
  ...valueDef("rehab_triggering_event"),
  ...valueDef("discharge_date"),
  ...valueDef("transfer_date"),
  // SECTION ONE
  ...valueDef("main_diagnosis"),
  ...valueDef("icd_code_1_code", {
    validate: (value, props) =>
      validateCharacterLimit(ICD_CODE_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("drg_code", {
    validate: (value, props) =>
      validateCharacterLimit(DRG_CODE_CHARACTER_LIMIT)(value, props),
  }),
  // SECTION TWO
  ...valueDef("complications"),
  ...valueDef("current_therapy"),
  ...valueDef("other_measures"),
  ...valueDef("further_therapeutic_diagnostic_measures_description"),
  ...valueDef("further_therapeutic_diagnostic_measures_from"),
  ...valueDef("further_therapeutic_diagnostic_measures_to"),
  ...valueDef("further_therapeutic_diagnostic_measures_finished_on"),
  // SECTION THREE
  ...valueDef("secondary_diagnosis_selected"),
  ...valueDef("icd_code_2_code", {
    validate: (value, props) =>
      validateCharacterLimit(ICD_CODE_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("icd_code_3_code", {
    validate: (value, props) =>
      validateCharacterLimit(ICD_CODE_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("secondary_diagnosis"),
  // SECTION FOUR
  ...valueDef("clinical_findings"),
  ...valueDef("patient_weight"),
  ...valueDef("patient_height"),
  // SECTION FIVE
  ...valueDef("eat_without_help"),
  ...valueDef("wash_and_dress_without_help"),
  ...valueDef("mobility_walk_without_help"),
  ...valueDef("wound_closed"),
  ...valueDef("infections_selected"),
  ...valueDef("infections", {
    validate: (value, props) =>
      validateCharacterLimit(INFECTIONS_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("urinary_incontinence"),
  ...valueDef("needs_catheter_selected"),
  ...valueDef("needs_catheter"),
  ...valueDef("fecal_incontinence"),
  ...valueDef("mobility_wheel_chair"),
  ...valueDef("orientation_disoriented_selected"),
  ...valueDef("orientation_disoriented"),
  ...valueDef("carelevel_selected"),
  ...valueDef("carelevel"),
  ...valueDef("transport_type"),
  ...valueDef("outpatient_not_possible_reason"),
  // SECTION SIX
  ...valueDef("insurance_delivery_address"),
  ...valueDef("hospital_bank_holder"),
  ...valueDef("hospital_bank_name"),
  ...ibanDef("hospital_iban"),
  ...valueDef("hospital_ik_number", {
    validate: (value, props) =>
      validateCharacterLimit(IK_NUMBER_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("hospital_billing_address"),
  // SECTION SEVEN
  ...valueDef("drv_remarks"),
});
